import React from 'react'
import RepeatableSection from './RepeatableSection'
import Container from './Container'
import { FlatDomainDataContext, FormBean, IUIRepeatableContainerDef } from '../../datatypes'
import {v4 as uuidv4} from 'uuid';

interface RepeatableContainerProps {
    metadata:IUIRepeatableContainerDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class RepeatableContainer extends React.Component<RepeatableContainerProps,{}> {

  render() {
    const callId = uuidv4();
    // console.debug(`RepeatableContainer render ${callId} componentId=${this.props.metadata.componentId}`);

    return (
      <Container {...this.props} className="repeatableContainer" useChildren={true}>
        <RepeatableSection {...this.props}/>
      </Container>
    )
  }
}